import { Dialog, DialogContent, DialogProps } from "@mui/material";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import VehicleDamageMigrateToNewVisualModel, {
  VehicleDamageMigrateToNewVisualModelProps,
} from "./VehicleDamageMigrateToNewVisualModel";

export interface OwnProps {
  migrateProps: VehicleDamageMigrateToNewVisualModelProps;
}

type Props = OwnProps & DialogProps;

export default function VehicleDamageMigrateToNewVisualModelModal({
  migrateProps,
  ...dialogProps
}: Props) {
  return (
    <Dialog fullWidth maxWidth='xl' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Migrate vehicle damage to new visual model
      </AppModalTitle>
      <DialogContent>
        <VehicleDamageMigrateToNewVisualModel
          {...migrateProps}
          onCancel={
            migrateProps.onCancel ||
            (() => {
              dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown");
            })
          }
        />
      </DialogContent>
    </Dialog>
  );
}
